import React, { useCallback, useEffect, useState } from 'react'

import Form from 'Atoms/Form'

const defaultOption = { value: null, label: '', disabled: true }

const OptionSelect = ({ facetOptions, selectedFacetId, setSelectedFacetId, testingName }) => {
  const [options, setOptions] = useState([defaultOption])

  useEffect(() => {
    if (facetOptions) {
      const updatedOptions = [
        defaultOption,
        ...facetOptions.map((facetOption) => ({
          value: facetOption.id,
          label: facetOption.name,
        })),
      ]
      setOptions(updatedOptions)
    }
  }, [facetOptions])

  const onChange = useCallback((e) => setSelectedFacetId(e.target.value), [setSelectedFacetId])

  return <Form.Select options={options} label={''} value={selectedFacetId} onChange={onChange} name={testingName} testingName={testingName} />
}

export default OptionSelect
